import httpApi from '@/utils/http-api'
import { api } from '@/config'

export default {
  addToCart: body => {
    return httpApi.postDataViaApi({
      url: api.cart.addToCart,
      body
    })
  },
  getCartItems: body => {
    return httpApi.getDataViaApi({
      url: api.cart.getCartItems,
      body
    })
  },
  createQuotation: body => {
    return httpApi.postDataViaApi({
      url: api.cart.createQuotation,
      body
    })
  },
  getAvailableTermsOfPayment: () => {
    return httpApi.getDataViaApi({
      url: api.cart.getAvailableTermsOfPayment
    })
  },
  downloadDealerPurchaseReport: body => {
    return httpApi.postDataViaApi({
      url: api.cart.dealerPurchaseReport,
      body
    })
  }
}
